__turbopack_context__.v({
  "input": "FloatingLabel-module__bpjgAq__input",
  "label": "FloatingLabel-module__bpjgAq__label",
  "required": "FloatingLabel-module__bpjgAq__required",
  "root": "FloatingLabel-module__bpjgAq__root",
});
